module.exports = __webpack_public_path__ + "img/outside_maruteru.ad6d4b90.jpg";